import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaopostomigragestoresfrentista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaopostomigragestoresfrentista/FIND_POSTOMIGRAGESTORESFRENTISTA':
      case '@operacaopostomigragestoresfrentista/UPDATE_POSTOMIGRAGESTORESFRENTISTA':
      case '@operacaopostomigragestoresfrentista/DELETE_POSTOMIGRAGESTORESFRENTISTA':
      case '@operacaopostomigragestoresfrentista/STORE_POSTOMIGRAGESTORESFRENTISTA':
      case '@operacaopostomigragestoresfrentista/POSTOMIGRAGESTORESFRENTISTA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaopostomigragestoresfrentista/SUCCESS_REMOVE':
      case '@operacaopostomigragestoresfrentista/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaopostomigragestoresfrentista/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaopostomigragestoresfrentista;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaopostomigragestoresfrentista/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaopostomigragestoresfrentista;
        break;
      }

      case '@operacaopostomigragestoresfrentista/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
